import type { FaireProductEntity } from "../../entity_types/product";

export const p_xhqk9tdnp3: FaireProductEntity = {
  token: "p_xhqk9tdnp3",
  type: "product",
  name: "HOT ROW - Chic Slip On Loafer Mules SHIPS FAST ✈️",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl: "https://cdn.faire.com/fastly/207dd048c686e30d2d5dd2dd1631adb884d5c41cfc6d76176dfbdbcf0ff89cff.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7756864e4a8a97139cee69fc91e97e6a9d507e59f2a8726070a1fc7e7d51c21a.jpeg",
    "https://cdn.faire.com/fastly/6ca0c457a3d1b96e5c0702bdd300bf0ba5b8690a27fc62de05d8b4565dd8c9e6.jpeg",
    "https://cdn.faire.com/fastly/98028158d1ccd3a0cfda1783f98ba17a1b958e6eaef6ce18cfaa70c03355ab1d.jpeg",
    "https://cdn.faire.com/fastly/678b7e38654b7e8de226dcacad30e96e5f55dcefa3c0e7bc4c08bc1dbf434628.jpeg",
    "https://cdn.faire.com/fastly/5490a6457f6122ac27376e53df147e71d5b07c46f7c1def54cde624954bf859c.jpeg",
    "https://cdn.faire.com/fastly/9a9211a7e007f13aa92754d249b7cfadf2de9f8ae02287fc0dd005faab7ce16b.jpeg",
    "https://cdn.faire.com/fastly/41795d7fc2b9e80ed9eee780d2a6cb7f2335c38952b6b5d39a33ebebeac03b36.jpeg"
  ],
  priceDollars: 14.25,
  description: "Classic, sleek, and endlessly versatile—HOT ROW is your new go-to for effortless style. Designed with a slip-on silhouette, these mules bring a polished touch to any outfit while keeping things easy and comfortable. The penny loafer detailing adds timeless charm, while the flat sole makes them perfect for all-day wear, from the office to after-hours plans.\n\nAvailable in black, chocolate suede, and black croc for a mix of minimalist and textured finishes.\n\nOOTD: Pair them with tailored trousers, a crisp button-down, and a structured blazer for a sharp office-ready look. On weekends, swap in relaxed denim and a slouchy knit for a chic off-duty vibe.",
  tags: [],
  msrpDollars: 30,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:07.714Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
